import { getBetStakeProps, getBetDataProps } from "../../bet";
export const getBetSummaryProps = (bet, state) => {
    return {
        betStake: getBetStakeProps(bet, state),
        betData: getBetDataProps(bet, state)
    };
};
//# sourceMappingURL=getBetSummaryProps.js.map